export const colors = {
  gencBlue: "#01959B",
  gencRed: "#FF0647",
  gencGrey: "#8E8E93",
  gencGrey2: "#C7C7CC",
  gencBlack: "#221F1F",
  gencWhite: "#FDFDFD",
  gencLightBlue: "#effcfb",
  facebookBlue: "#3b5998",
  twitterBlue: "#1da1f2",
};
